
import actionTypeConstants from "../utils/actionTypeConstants";
function customerJourneyReducer(state = {}, action = {} as any) {

    switch (action.type) {
      case actionTypeConstants.CUSTOMER_JOURNEY:
        return {
          ...state,
          ...action.payload,
          
        };
      case '':
          return state
      default:
          return state
    }
  }
  
  export default customerJourneyReducer;